import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  YoutubeIcon,
} from '@twistopayments/design-system/icons/social'

import type { LinksSocialMediaLinkComponent } from '@twisto/api-cms'

import { socialMediaIcon } from './footer.styles'

type SocialIconsProps = {
  icons: LinksSocialMediaLinkComponent[]
}

const socialMediaLogos = {
  facebook: <FacebookIcon />,
  instagram: <InstagramIcon />,
  youtube: <YoutubeIcon />,
  linkedin: <LinkedinIcon />,
}

export const SocialIcons = ({ icons }: SocialIconsProps) => (
  <div>
    {icons.map(({ id, icon, url }) => (
      <TextButton
        key={id}
        color="ghost"
        css={socialMediaIcon}
        href={url}
        size="small"
      >
        {icon && socialMediaLogos[icon]}
      </TextButton>
    ))}
  </div>
)
